export default __webpack_public_path__ + "static/media/preview.1e775aa4.png";